import { useEffect } from "react";
import { useForm } from "react-hook-form"
import { useSelector } from "react-redux"
import ReactStars from "react-rating-stars-component";
import { RxCross2 } from "react-icons/rx"
import IconButton from "../../Common/IconButton";
import { createRating } from "../../../Services/Operations/CourseAPI";

export default function CourseReviewModal({setReviewModal}){

    const {user}=useSelector((state)=>state.profile)
    const {token}=useSelector((state)=>state.auth)
    const {courseEntireData}=useSelector((state)=>state.viewCourse)
    const {handleSubmit,register,setValue,getValues,formState:{errors}}=useForm();

    useEffect(()=>{
        setValue("courseExperience","");
        setValue("courseRating",0);
    },[]);

    const handleOnSubmit=async (data)=>{
        await createRating({
            courseId:courseEntireData._id,
            rating:data.courseRating,
            review:data.courseExperience,
        },token)
    }

    const ratingChanged=(newRating)=>{
        setValue("courseRating",newRating);

    }

    return (
        <div className="fixed inset-0 z-[1000] !mt-0 grid h-screen w-screen place-items-center overflow-auto bg-white bg-opacity-10 backdrop-blur-sm">
            <div className="my-10 w-11/12 max-w-[700px] rounded-lg border border-richblack-400 bg-richblack-800 ">
                <div className="flex items-center justify-between rounded-t-lg bg-richblack-700 p-5">
                    <p className="text-xl font-semibold text-richblack-5">Add Review</p>
                    <button onClick={()=>setReviewModal(false)}>
                        <RxCross2 className="text-2xl text-richblack-5" />
                    </button>
                </div>
                <div className="p-6">
                    <div className="flex items-center justify-center gap-x-4">
                        <img src={user?.image} alt ={user.firstName}
                            className="aspect-square w-[50px] rounded-full object-cover"
                        />
                        <div>
                            <p className="font-semibold text-richblack-5">
                                {user?.firstName} {user?.lastName}
                            </p>
                            <p className="text-sm text-richblack-5">Posting Publicly</p>
                        </div>

                        <form
                        onSubmit={handleSubmit(handleOnSubmit())} className="mt-6 flex flex-col items-center">

                            <ReactStars
                                count={5}
                                onChange={ratingChanged}
                                size={24}
                                activeColor="#ffd700"
                            />

                            <div className="flex w-11/12 flex-col space-y-2">
                                <label className="text-sm text-richblack-5">
                                    <p>
                                        Add Your Experience
                                        <sup className="text-pink-200">*</sup>
                                    </p>
                                    <textarea
                                        id="courseExperience"
                                        placeholder="Add Your Experience here"
                                        {...register("courseExperience",{required:true})}
                                        style={{boxShadow: "inset 0px -1px 0px rgba(255, 255, 255, 0.18)"}}
                                        className="w-full rounded-[0.5rem] 
                                        resize-x-none min-h-[130px] bg-richblack-800 p-[12px] text-richblack-5 mt-2"
                                    />
                                    {
                                        errors.courseExperience && (
                                            <span className="ml-2 text-xs tracking-wide text-pink-200">
                                            Please add your experience
                                            </span>
                                        )
                                    }
                                </label>
                            </div>
                            <div className="mt-6 flex w-11/12 justify-end gap-x-2">
                                <button onClick={()=>setReviewModal(false)}
                                className={`flex cursor-pointer items-center gap-x-2 rounded-md bg-richblack-300 py-[8px] px-[20px] font-semibold text-richblack-900`}>
                                    Cancel
                                </button>
                                <IconButton
                                    text={"Save"}
                                />
                            </div>
                        </form>                       
                    </div>
                </div>
            </div>
        </div>
    )
}